module.exports = __webpack_public_path__ + "media/images/story/typo/greetingsNormal-8e02893ee425f3b94cc569d7026bd871.svg";